import Vue from 'vue';
import App from './App';
import { router } from './router';
import dayjs from "dayjs";

import VueI18n from 'vue-i18n'
import messages from "./lang/index"
Vue.use(VueI18n);
const i18n = new VueI18n({
  //定义默认语言
  locale: localStorage.getItem('lang') || 'zhCH',
  messages
});

/*vue上挂载vant i18n方法*/
import {Locals} from './lang/vantLocal.js'
Vue.prototype.$Local = Locals;

/*vue上挂载wx jssdk方法*/
import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx;

// /*开启测试工具*/
// import Vconsole from 'vconsole'

// let vConsole = new Vconsole()
// Vue.use(vConsole)

/*配置axios*/
import Axios from "axios";
Axios.defaults.baseURL = '/asset_cp/';
// 请求超时时间
Axios.defaults.timeout = 10000;
// 请求拦截器
Axios.interceptors.request.use(
  config => {
    console.log("请求拦截器",localStorage.getItem("user_id"))
    config.headers.subdomain = 'dan';
    config.params = {
      userId: localStorage.getItem("user_id"),
      // 15600109290 18404984128
      // userId: "eOSBRJPtsT3I+Yj2+gv8yg==",
      ...config.params
    }
    return config;
  },
  error => {
    return Promise.error(error);
  })
// 响应拦截器
Axios.interceptors.response.use(
  response => {
    // 判断状态码成功还是失败
    if (response.data.code === 0) {
      return Promise.resolve(response.data.data);
    } else {
      return Promise.reject(response.data.msg);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log('服务器异常',error)
    return Promise.reject('服务器异常');
  }
);
/*vue上挂载axios*/
Vue.prototype.$axios = Axios;

/*开启token拦截*/
let whiteList = ['/auth', '/service', '/service/help'];
router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  const authDate = localStorage.getItem('auth_date');
  console.log(localStorage.getItem('now_url'))
  if (whiteList.includes(to.path) || authDate === dayjs(new Date()).format('YYYY-MM-DD')) {
    if (title) {
      document.title = i18n.t(title);
    }
    next();
  } else {
    // alert('登录校验前的路径'+location.href)
    if(location.href.indexOf('code') == -1) {
      // alert('我保存的路径'+ location.href)
      localStorage.setItem('now_url',location.href); //当前页url与参数放入缓存
    }
    next('/auth') //微信环境用
    // next() //测试用
  }

});

var vue = new Vue({
  router,
  i18n,
  el: '#app',
  render: h => h(App)
});

export default vue
